<template>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 pb-8 lg:pb-12">
        <div>
            <component :is="leftComponent" :content="leftSlot.data" />
        </div>

        <div>
            <component :is="rightComponent" :content="rightSlot.data" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { HblSlot } from '@/utils/types'
import { hblToUpperCamelCase } from '@/utils/helper'

const props = defineProps<{
    content: HblSlot[]
}>()

const leftSlot = computed(() => {
    return props.content.find(item => item.position === 'left')
})

const rightSlot = computed(() => {
    return props.content.find(item => item.position === 'right')
})

const leftComponent = computed(() => {
    if (!leftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(leftSlot.value.type)}`
})

const rightComponent = computed(() => {
    if (!rightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(rightSlot.value.type)}`
})
</script>
